const STATUS_CODES = ["invited", "registered", "present", "declined", "waiting_list", "waiting_for_payment"];

function normalizeParticipantStatuses(value) {
  if (!Array.isArray(value)) throw new Error("Participant statuses are unavailable.");
  const byCode = new Map();
  for (const status of value) {
    if (STATUS_CODES.includes(status?.code) && typeof status.statusId === "string" && status.statusId) {
      byCode.set(status.code, { statusId: status.statusId, code: status.code, name: status.name });
    }
  }
  if (byCode.size !== STATUS_CODES.length) throw new Error("Participant statuses are incomplete.");
  return STATUS_CODES.map(code => byCode.get(code));
}

function statusIdFor(statuses, code) {
  return statuses.find(status => status.code === code)?.statusId || null;
}

function statusCodeFor(statuses, statusId) {
  return statuses.find(status => status.statusId === statusId)?.code || null;
}

module.exports = { STATUS_CODES, normalizeParticipantStatuses, statusIdFor, statusCodeFor };
